export enum ProductType {
  Wheel = "wheel",
  Wheelbase = "wheelbase",
  Pedals = "pedals",
  HPatternShifter = "hPatternShifter",
  SequentialShifter = "sequentialShifter",
}
